import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import { isCommodityCode } from "web_myplann/Portfolio/Forms/ToolsShared/constants";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";

export const getCommodityLabel = (
	identification: string,
	t: TranslateFunction,
) =>
	isCommodityCode(identification)
		? t(Resources.Portfolio.AddTools.Identification[identification])
		: identification;
